import React, { useContext, useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { navigate } from '@reach/router';
import Nav from '../nav';
import AppStateContext from '../../context/appStateContext';
import DialogForcedLogout from "../Dialogs/dialogForcedLogout";

interface PrivateRouteProps {
  children: React.ReactChild[];
  path: string;
}

const PrivateRoute2: React.FC<PrivateRouteProps> = ({
  children,
  path: Path,
}: PrivateRouteProps): React.ReactElement => {
  const { token,currentPage } = useContext(AppStateContext);

  useEffect(() => {
    if (!token && Path !== '/') {
      navigate('/');
    } else if (token && Path === '/') {
      navigate('/app/selectContract');
    }
  }, [Path, token]);

  return token ? (
    <React.Fragment>
      {currentPage != 'selectContract' && <Nav />}
      {children}
      {token == 'expired' && <DialogForcedLogout message='Your token has expired!'/>}
    </React.Fragment>
  ) : (
    <React.Fragment />
  );
};

export default PrivateRoute2;
